import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { useEntityMgr } from '../../../common/entityFramework/entityView/EntityMgrContext';
import { CustCotList } from '../custCot/CustCotList';
import { CustForm } from '@/md/entities/cust/CustForm';


export const CotDetail = () => {
  
  const { entityObj } = useEntityMgr();

  const tabSpecs = [
    { id: 'info', label: 'Info', content: <CustForm /> },
    { id: 'custs', label: 'Customers', content: <CustCotList cotId={entityObj.id}/> },
  ];

  return (
    <EntityDetail tabSpecs={tabSpecs} />
  )
}